import { Link } from 'react-router-dom';

const PartnersSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-graphite mb-4">
            Colaboramos con <span className="text-primary">profesionales</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-2xl mx-auto">
            Trabajamos con inmobiliarias, administradores de fincas, servicios sociales y particulares. <Link to="/servicios" className="text-primary hover:underline font-semibold">Ver todos nuestros servicios</Link>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-silver-light/30 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-building-line text-white text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-graphite mb-3">Inmobiliarias</h3>
            <p className="text-gray-dark leading-relaxed">
              Servicio rápido y profesional para preparar pisos y locales antes de la venta o alquiler. Presupuestos especiales para colaboraciones continuadas.
            </p>
          </div>

          <div className="bg-silver-light/30 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-community-line text-white text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-graphite mb-3">Comunidades</h3>
            <p className="text-gray-dark leading-relaxed">
              Colaboramos con administradores de fincas en vaciados de pisos abandonados, trasteros y zonas comunes. Servicio discreto y eficiente.
            </p>
          </div>

          <div className="bg-silver-light/30 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-user-heart-line text-white text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-graphite mb-3">Particulares</h3>
            <p className="text-gray-dark leading-relaxed">
              Atención personalizada para familias que necesitan vaciar pisos por herencias, mudanzas o situaciones delicadas. Trato humano y comprensivo.
            </p>
          </div>
        </div>

        <div className="bg-primary/5 rounded-3xl p-12 text-center">
          <h3 className="text-3xl font-bold text-graphite mb-4">
            ¿Eres profesional del sector inmobiliario?
          </h3>
          <p className="text-lg text-gray-dark mb-8 max-w-2xl mx-auto">
            Ofrecemos condiciones especiales y tarifas preferenciales para inmobiliarias, administradores de fincas y profesionales con necesidades recurrentes de vaciado y limpieza. <Link to="/faq" className="text-primary hover:underline font-semibold">Consulta preguntas frecuentes</Link>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:info@castelldefels.justclean.es"
              className="inline-flex items-center px-8 py-4 bg-primary text-white rounded-lg font-semibold text-lg hover:bg-primary-dark hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Solicita información para profesionales
            </a>
            <Link
              to="/contacto"
              className="inline-flex items-center px-8 py-4 border-2 border-primary text-primary rounded-lg font-semibold text-lg hover:bg-primary hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Contactar ahora
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
